"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintRefDataObjectBuilder = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_three_utils_1 = require("realms-three-utils");
var realms_three_1 = __importDefault(require("realms-three"));
var AbstractDataObjectBuilder_1 = require("./AbstractDataObjectBuilder");
var BlueprintRefDataObjectBuilder = /** @class */ (function (_super) {
    __extends(BlueprintRefDataObjectBuilder, _super);
    function BlueprintRefDataObjectBuilder(buildAnyThreeObject) {
        var _this = _super.call(this) || this;
        _this.buildAnyThreeObject = buildAnyThreeObject;
        return _this;
    }
    BlueprintRefDataObjectBuilder.prototype.createDataObject = function (params) {
        return __assign(__assign({}, this.utils.createBaseDataObject(params)), { type: realmforge_common_1.DataObjectType.BlueprintRef, ref: params.ref });
    };
    BlueprintRefDataObjectBuilder.prototype.getDefaultCreateParams = function (params) {
        return null;
    };
    BlueprintRefDataObjectBuilder.prototype.buildThreeObject = function (dataObject, allDataObjects, methods) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = this.utils).setThreeProperties;
                        _c = [dataObject];
                        return [4 /*yield*/, this.buildBlueprintRef(dataObject, allDataObjects, methods)];
                    case 1: return [2 /*return*/, _b.apply(_a, _c.concat([_d.sent()]))];
                }
            });
        });
    };
    BlueprintRefDataObjectBuilder.prototype.updateDataObject = function (oldDataObject, params) {
        return __assign(__assign({}, oldDataObject), this.utils.updateBaseDataObject(oldDataObject, params));
    };
    BlueprintRefDataObjectBuilder.prototype.updateThreeObject = function (params, threeObject) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.utils.setThreeProperties(params, threeObject)];
            });
        });
    };
    /*
     * Builds a blueprint ref
     */
    BlueprintRefDataObjectBuilder.prototype.buildBlueprintRef = function (dataObject_1, allDataObjects_1, methods_1) {
        return __awaiter(this, arguments, void 0, function (dataObject, allDataObjects, methods, options) {
            var refDataObjects, idToDataObject, dataObjectToThree, refDataObjects_1, refDataObjects_1_1, refDataObject, _a, _b, _c, e_1_1, rootRefObject, _d, _e, _f, dataObject_2, threeObj, parentDataObject, parentThreeObj;
            var e_1, _g, e_2, _h;
            var _j;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        refDataObjects = allDataObjects.filter(function (obj) { return obj.blueprintId === dataObject.ref.blueprintId; });
                        idToDataObject = Object.fromEntries(refDataObjects.map(function (dataObject) { return [dataObject.id, dataObject]; }));
                        dataObjectToThree = new Map();
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 6, 7, 8]);
                        refDataObjects_1 = __values(refDataObjects), refDataObjects_1_1 = refDataObjects_1.next();
                        _k.label = 2;
                    case 2:
                        if (!!refDataObjects_1_1.done) return [3 /*break*/, 5];
                        refDataObject = refDataObjects_1_1.value;
                        // Build the data object
                        _b = (_a = dataObjectToThree).set;
                        _c = [refDataObject];
                        return [4 /*yield*/, this.buildAnyThreeObject(refDataObject, allDataObjects, methods)];
                    case 3:
                        // Build the data object
                        _b.apply(_a, _c.concat([_k.sent()]));
                        _k.label = 4;
                    case 4:
                        refDataObjects_1_1 = refDataObjects_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _k.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (refDataObjects_1_1 && !refDataObjects_1_1.done && (_g = refDataObjects_1.return)) _g.call(refDataObjects_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        rootRefObject = (_j = options.rootRefObject) !== null && _j !== void 0 ? _j : new realms_three_1.default.Object3D();
                        (0, realms_three_utils_1.disposeThreeObject)(rootRefObject);
                        rootRefObject.clear();
                        try {
                            for (_d = __values(Array.from(dataObjectToThree.entries())), _e = _d.next(); !_e.done; _e = _d.next()) {
                                _f = __read(_e.value, 2), dataObject_2 = _f[0], threeObj = _f[1];
                                if (dataObject_2.parentId === null) {
                                    rootRefObject.add(threeObj);
                                }
                                else {
                                    parentDataObject = idToDataObject[dataObject_2.parentId];
                                    if (!parentDataObject) {
                                        throw new Error("Parent DataObject ".concat(dataObject_2.parentId, " does not exist"));
                                    }
                                    parentThreeObj = dataObjectToThree.get(parentDataObject);
                                    if (!parentThreeObj) {
                                        throw new Error("Parent DataObject ".concat(dataObject_2.parentId, " does not have corresponding three object"));
                                    }
                                    parentThreeObj.add(threeObj);
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_h = _d.return)) _h.call(_d);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/, rootRefObject];
                }
            });
        });
    };
    return BlueprintRefDataObjectBuilder;
}(AbstractDataObjectBuilder_1.AbstractDataObjectBuilder));
exports.BlueprintRefDataObjectBuilder = BlueprintRefDataObjectBuilder;
